<template>
  <div>
    <div id="skill-table">
      <table class="table table-hover ui-table mb-4 mt-2">
        <thead>
          <tr>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.date_from'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.date_to'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.skill'
                )
              }}
            </th>
            <th>
              {{
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.level'
                )
              }}
            </th>
            <th style="width: 3%" class="text-center">
              <a href="#" @click.prevent="addNewRow">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(skill, index) in teacher_skill_list" :key="index">
            <td style="width: 12%">
              <a-date-picker
                v-model="skill.from_date"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
                class="ts-w-full"
              />
              <div
                class="validate"
                v-if="errors.has('teacher_skill_list.' + index + '.from_date')"
              >
                {{ errors.first('teacher_skill_list.' + index + '.from_date') }}
              </div>
            </td>
            <td style="width: 12%">
              <a-date-picker
                v-model="skill.to_date"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
                class="ts-w-full"
              />
              <div
                class="validate"
                v-if="errors.has('teacher_skill_list.' + index + '.to_date')"
              >
                {{ errors.first('teacher_skill_list.' + index + '.to_date') }}
              </div>
            </td>
            <td>
              <a-input
                type="text"
                v-model.trim="skill.skill_description"
                class="ts-w-full"
              />
              <div
                class="ts-text-red-500"
                v-if="
                  errors.has(
                    'teacher_skill_list.' + index + '.skill_description'
                  )
                "
              >
                {{
                  errors.first(
                    'teacher_skill_list.' + index + '.skill_description'
                  )
                }}
              </div>
            </td>
            <td>
              <a-select
                v-model="skill.level_id"
                style="min-width: 100px;"
                class="ts-w-full"
                :options="[
                  {
                    value: 1,
                    label: $t('teacherprofile.level1')
                  },
                  {
                    value: 2,
                    label: $t('teacherprofile.level2')
                  },
                  {
                    value: 3,
                    label: $t('teacherprofile.level3')
                  }
                ]"
              ></a-select>
              <div
                class="ts-text-red-500"
                v-if="errors.has('teacher_skill_list.' + index + '.level_id')"
              >
                {{ errors.first('teacher_skill_list.' + index + '.level_id') }}
              </div>
            </td>
            <td>
              <a href="#" class="text-danger" @click.prevent="removeRow(skill)">
                <i class="fa fa-trash mt-2"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'skill',
  props: ['value', 'validate'],
  data() {
    return {
      teacher_skill_list: [],
      newRow: {
        skill_description: '',
        level_id: '',
        from_date: '',
        to_date: ''
      },
      errors: new Errors()
    }
  },
  created() {
    this.teacher_skill_list = this.value
  },
  computed: {
    ...mapState('teacherProfile', ['edit_data'])
  },
  methods: {
    addNewRow() {
      this.teacher_skill_list.push(Object.assign({}, this.newRow))
    },
    removeRow(row) {
      this.teacher_skill_list.splice(this.teacher_skill_list.indexOf(row), 1)
    }
  },
  watch: {
    value: {
      handler() {
        this.teacher_skill_list = this.value
      }
    },
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
#skill-table {
  max-height: 20vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#skill-table::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
#skill-table::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
